const FilmPrice = {
	// $29.99 for the first 100 feet; $0.25 per foot after first 100
	rule: function (price, filmFeetTotal, isSale) {
		const upsellTotal =
			Number($(".product-price").attr("data-upsell-dvd-total-price")) +
			Number($(".product-price").attr("data-upsell-usb-total-price")) +
      Number($(".product-price").attr("data-upsell-enhanced-content-total-price"));

    var extraItemPrice = Number($(".product-price").attr("data-extra-price"));
    const includedQuantity = Number($(".product-price").attr("data-included-quantity"));
		var extraCharge = extraItemPrice;

		var newPrice = 0;

    var extraQuantity = filmFeetTotal - includedQuantity;

    newPrice += price;

    if (extraQuantity > 0) {
      // add any extra quantity
      newPrice += extraCharge * extraQuantity;
    }

		newPrice += upsellTotal;
		return [newPrice, formatMoney(newPrice)];
	},
	variants: function (callback) {
		var filmQuantityInputs = $('input[name="film-quantity"]');
		var filmQuantityPriceTotalWrapper = $(
			".product-price-quantity .film-quantity .label-quantity"
		);
		var filmQuantityPriceFeetWrapper = $(
			".product-price-quantity .feet-quantity .label-quantity"
		);
		var submitButton = $("button.product-form__submit");

		filmQuantityInputs.change(function (e) {
			var value = Number($(this).val());
			var errorMessageWrapper = $(".product-film__error-message-wrapper");
			if (value > CONSTANTS.FILM.MAX_INPUT) {
				$(this).val(CONSTANTS.FILM.MAX_INPUT);
				errorMessageWrapper.removeAttr("hidden");
				errorMessageWrapper
					.find(".product-film__error-message")
					.text(
						`Maximum quantity for film input is ${CONSTANTS.FILM.MAX_INPUT}`
					);
			} else {
				errorMessageWrapper.attr("hidden", true);
			}

			var filmFeetTotal = 0;
			var filmQuantity = 0;
			// Update total number of film feet
			filmQuantityInputs.each(function (i, e) {
				var value = Number($(this).val());
				var feetValue = Number($(this).attr("data-feet"));
				if (value) {
					filmQuantity += value;
					filmFeetTotal += value * feetValue;
				}
			});

			filmQuantityPriceTotalWrapper.text(filmQuantity);
			filmQuantityPriceFeetWrapper.text(filmFeetTotal);

			if (filmQuantity > 0) {
				if (submitButton.prop("disabled")) {
					submitButton.prop("disabled", false);
				}
			} else {
				submitButton.prop("disabled", true);
			}

			// Callback
			if (callback) {
				callback(filmFeetTotal);
			}
		});
	},

  dynamicPrice: function() {
    const extraItemPrice          = Number($(".product-price").attr("data-extra-price"));
    const extraItemCompareAtPrice = Number($(".product-price").attr("data-extra-compare-at-price"));
    const includedQuantity        = Number($(".product-price").attr("data-included-quantity"));
  	const productPrice            = Number($(".product-price").attr("data-price"));
    const productCompareAtPrice   = Number($(".product-price").attr("data-compare-price"));

    if (extraItemPrice) {
      $(".unit-item-extra-item-price").text( formatMoney(extraItemPrice) );
    }

    if (extraItemCompareAtPrice) {
      $(".unit-item-extra-item-compare-at-price").text( formatMoney(extraItemCompareAtPrice) );
    }

    if (productPrice) {
      $(".unit-item-price").text( formatMoney(productPrice) );
    }

    if (productCompareAtPrice) {
      $(".unit-item-compare-at-price").text( formatMoney(productCompareAtPrice) );
    }

    if (includedQuantity) {
      $(".unit-item-included-quantity").text( includedQuantity );
    }
  },


};

document.addEventListener("DOMContentLoaded", () => {
	const priceRegularWrapper = $(".product-price .price-item--regular");
	const priceSaleWrapper = $(".product-price .price-item--sale");
	const originalPrice = Number(
		$(".product-price").attr("data-compare-price")
	);
	const originalSalePrice = Number($(".product-price").attr("data-price"));

  FilmPrice.dynamicPrice();

	FilmPrice.variants((filmFeetTotal) => {
		const [newPriceRegular, newPriceRegularFormatted] = FilmPrice.rule(
			originalPrice,
			filmFeetTotal
		);
		const [newPriceSale, newPriceSaleFormatted] = FilmPrice.rule(
			originalSalePrice,
			filmFeetTotal,
			true
		);
		priceRegularWrapper.text(newPriceRegularFormatted);
		priceSaleWrapper.text(newPriceSaleFormatted);
		$(".product-price").attr("data-total-price", newPriceSale);
		$(".product-price").attr("data-total-compare-price", newPriceRegular);
	});
});